module.exports = __webpack_public_path__ + "files/dba9cb6d299527acba3dc9235f62d3b2.png";